module.exports = __webpack_public_path__ + "img/0.2879ea9a.jpg";